import React from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import LobbyContainer from '../containers/LobbyContainer'
import Game from './Game'

const Root = ({ store }) => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/" exact component={LobbyContainer} />
        <Route path="/s/:sessionId" exact component={Game} />
        <Redirect to="/" />
      </Switch>
    </Router>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired
}

export default Root
